import { render, staticRenderFns } from "./TagFileType.vue?vue&type=template&id=127a7c0c&scoped=true&"
import script from "./TagFileType.vue?vue&type=script&lang=js&"
export * from "./TagFileType.vue?vue&type=script&lang=js&"
import style0 from "./TagFileType.vue?vue&type=style&index=0&id=127a7c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127a7c0c",
  null
  
)

export default component.exports